import styled from "styled-components"
import ProgressiveImage from "react-progressive-bg-image"

export const ContainerFluid = styled.div`
  text-align: center;
  margin-top: 5rem;
`
export const Container = styled.div`
  width: 65%;
  margin: auto;

  @media (max-width: 1600px) {
    width: 80%;
  }

  @media (max-width: 1400px) {
    width: 90%;
  }
`
export const Header6 = styled.h6`
  font-weight: 500;
  color: #10ad62;
`
export const Header3 = styled.h3`
  margin-top: 0.5rem;
`

export const CardWrapper = styled.div`
  height: ${props => (props.height ? props.height : "31rem")};
  width: 21rem;
  border: 1px solid #c7c7c7;
  border-radius: 6px;
  margin: 1.5rem;
  position: relative;
  @media (min-width: 400px) and (max-width: 768px) {
    margin: 3% 2%;
    height: ${props => (props.tabHeight ? props.tabHeight : "25rem")};
    width: 45%;
  }
  @media (max-width: 400px) {
    width: 90%;
    max-width: 18.5rem;
    min-height: 23rem;
    max-height: 31rem;
  }
`
export const ImageContainer = styled.div`
  height: 40%;
  margin-bottom: 5%;
  width: 100%;
  border-radius: 6px 6px 0rem 0rem;
  overflow: hidden;
`
export const ImageSection = styled.img`
  height: 100%;
  width: 100%;
`

export const Text = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 400px) and (max-width: 768px) {
    margin-top: 10px;
  }
`
export const Heading = styled.div`
  font-size: 18px;
  margin: 10px 0rem;
  font-weight: 600;
  line-height: 21px;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 40px;
  @media (min-width: 400px) and (max-width: 768px) {
    margin: 5px 0rem;
    font-size: 13px;
  }
`
export const Heading1 = styled.h3`
  font-size: 18px;
  margin: 10px 0rem;
  font-weight: 600;
  line-height: 21px;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 40px;
  @media (min-width: 400px) and (max-width: 768px) {
    margin: 5px 0rem;
    font-size: 13px;
  }
`

export const Subheading = styled.div`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  margin: 10px 0rem;
  height: 60px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  text-overflow: ellipsis;
  line-height: 20px;
  font-size: 16px;
  @media (min-width: 400px) and (max-width: 768px) {
    display: none;
  }
`
export const Content = styled.div`
  margin-bottom: 5px;
  overflow: hidden;
`
export const Name = styled.div`
  color: #535353;
  height: 25px;
  padding: 0;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
`
export const Date = styled.div`
  display: flex;
  align-items: center;
  color: #858585;
  margin-left: 5px;
`
export const UserAvatarContainer = styled.div`
  position: absolute;
  height: 38px;
  width: 38px;
  border-radius: 25px;
  top: 34%;
  overflow: hidden;
  border: 1px solid #4aa958;
  left: 1rem;
`
export const ReadMore = styled.div`
  color: #00a857;
  display: flex;
  align-items: flex-end;
`

export const TextContainer = styled.div`
  height: 55%;
  padding: 0.4rem 0.9rem 0.4rem 0.9rem;
`
export const SavedIcon = styled.div`
  display: flex;
  cursor: pointer;
`
export const BlogsImage = styled(ProgressiveImage)`
  width:100%;
  height:100%;
  background-position:center;
  background-image:url('${props => props.src}');
  background-size:cover
`
export const TagContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 75px;
  height: 75px;
  overflow: hidden;
  margin-bottom: 3px;
`
export const TagsList = styled.div`
  width: fit-content;
  border: 1px solid #4aa958;
  padding: 1px 8px;
  border-radius: 15px;
  font-weight: 600;
  margin: 5px;
`
